"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Textarea = ( /*#__PURE__*/0, _styledBase["default"])(_.Input, {
  target: "efkeh2o0",
  label: "Textarea"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RleHRhcmVhL1RleHRhcmVhLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJOEIiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVGV4dGFyZWEvVGV4dGFyZWEuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCB7IElucHV0IH0gZnJvbSAnLi4vJztcblxuY29uc3QgVGV4dGFyZWEgPSBzdHlsZWQoSW5wdXQpYGA7XG5cblRleHRhcmVhLnByb3BUeXBlcyA9IHtcbiAgLi4uSW5wdXQucHJvcFR5cGVzLFxuICByb3dzOiBQcm9wVHlwZXMubnVtYmVyLFxufTtcblxuVGV4dGFyZWEuZGVmYXVsdFByb3BzID0ge1xuICAuLi5JbnB1dC5kZWZhdWx0UHJvcHMsXG4gIGFzOiAndGV4dGFyZWEnLFxuICByb3dzOiA2LFxufTtcblxuZXhwb3J0IGRlZmF1bHQgVGV4dGFyZWE7XG4iXX0= */");
Textarea.propTypes = _objectSpread(_objectSpread({}, _.Input.propTypes), {}, {
  rows: _propTypes["default"].number
});
Textarea.defaultProps = _objectSpread(_objectSpread({}, _.Input.defaultProps), {}, {
  as: 'textarea',
  rows: 6
});
var _default = Textarea;
exports["default"] = _default;